module.exports = __webpack_public_path__ + "static/media/OracleDBA_L1.f490a483.jpg";